import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoHeaderModel } from 'src/app/model/odonto/header';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-header',
  templateUrl: './odonto.header.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoHeaderComponent,
      multi: true,
    },
  ],
})
export class OdontoHeaderComponent extends BaseValueAccessor<OdontoHeaderModel> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
}
